import { AlertTriangle } from "lucide-react";
import { Link } from "react-router-dom";

export function BookingPayCancel() {
  return (
    <div className="max-w-lg mx-auto space-y-8 text-center">
      <div className="flex justify-center">
        <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center">
          <AlertTriangle className="w-8 h-8 text-orange-600" />
        </div>
      </div>
      <div>
        <h1 className="text-3xl font-bold text-gray-900 mb-2">
          Payment cancelled
        </h1>
        <p className="text-gray-600 text-lg">
          No payment was taken. You can use the payment link again whenever you
          are ready.
        </p>
      </div>
      <Link
        to="/"
        className="inline-flex justify-center rounded-md border border-transparent bg-primary-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-primary-700"
      >
        Return home
      </Link>
    </div>
  );
}
